import React from "react";
import { Outlet } from "react-router-dom";
import BG from "../../assets/image/background-img.jpg";

const AuthLayout = () => {
  return (
    <div className="row mx-0">
      <div className="col-md-5 px-0">
        <div>
          <Outlet />
        </div>
      </div>
      <div className="col-md-7 px-0">
        <img src={BG} alt="" className="img-fluid w-100 h-100 object-fit-cover" />
      </div>
    </div>
  );
};

export default AuthLayout;
